module.exports = __webpack_public_path__ + "img/shipping-PostExpress.f51e83bd.png";